module.exports = __webpack_public_path__ + "static/fonts/iconfont.81aee844.woff2";